export { ResetPasswordComponent } from "./reset-password.component";
